/* =| 外部アクセス |= */

import { fetchURI } from '../value/dataValues'

//--
// 外部サーバーへアクセスしてデータを取ってくる
export async function apiRequest() {
  // レスポンスはそのまま返す
  return await fetch(fetchURI()).then(async (res) => res);
}